import { render, staticRenderFns } from "./rgb.vue?vue&type=template&id=2cd21782&scoped=true&"
import script from "./rgb.js?vue&type=script&lang=js&"
export * from "./rgb.js?vue&type=script&lang=js&"
import style0 from "./rgb.css?vue&type=style&index=0&id=2cd21782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd21782",
  null
  
)

export default component.exports